import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackDemoEvent } from './trackDemoEvent';

/**
 * Mounts once inside the Router context and fires a 'surface_visit'
 * analytics event for the active demo session every time the pathname
 * changes. Quietly no-ops for non-demo users (trackDemoEvent reads the
 * auth store and short-circuits).
 *
 * Path -> surface name mapping is deliberately coarse: we want the
 * dashboard to count "did they touch Cleo / Rooms / Updates / Map /
 * Profile" rather than count every sub-route. Unknown paths fire a
 * generic surface_visit with the raw path as metadata for forensics.
 */

function surfaceFromPath(pathname: string): string | null {
  if (pathname.startsWith('/cleo')) return 'cleo';
  if (pathname.startsWith('/horizon')) return 'horizon';
  if (pathname.startsWith('/rooms')) return 'rooms';
  if (pathname.startsWith('/updates')) return 'updates';
  if (pathname.startsWith('/map')) return 'map';
  if (pathname.startsWith('/you') || pathname.startsWith('/profile')) return 'profile';
  if (pathname.startsWith('/matching')) return 'matching';
  if (pathname.startsWith('/event-chat') || pathname.startsWith('/dm')) return 'chat';
  return null;
}

export function DemoSurfaceTracker(): null {
  const location = useLocation();

  useEffect(() => {
    const surface = surfaceFromPath(location.pathname);
    if (!surface) return;
    trackDemoEvent({
      type: 'surface_visit',
      name: `${surface}_opened`,
      surface,
      metadata: { path: location.pathname },
    });
  }, [location.pathname]);

  return null;
}
